'use es6';

import makeCurrencyField from './makeCurrencyField';
export default {
  deal_currency_code: makeCurrencyField()
};